import React, { useEffect, useRef } from "react";

const SearchBox = ({ onPlaceSelected, value = "" }) => {
  const inputRef = useRef(null);
  const onPlaceSelectedRef = useRef(onPlaceSelected);

  useEffect(() => {
    onPlaceSelectedRef.current = onPlaceSelected;
  }, [onPlaceSelected]);

  useEffect(() => {
    const input = inputRef.current;
    if (!input || !window.google?.maps?.places) return;

    const autocomplete = new window.google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "ar" },
      fields: ["formatted_address", "geometry", "name"],
    });

    const listener = autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place?.geometry?.location) return;
      onPlaceSelectedRef.current(place);
    });

    return () => {
      window.google.maps.event.removeListener(listener);
    };
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = value || "";
    }
  }, [value]);

  return (
    <input
      ref={inputRef}
      id="pac-input"
      type="text"
      placeholder="Buscar ubicación en Argentina"
      defaultValue={value}
    />
  );
};

export default SearchBox;
